import type { RootState } from 'store'
import type { ActionTree } from 'vuex'
import { AuthService } from '../service'
import { useCookies } from 'vue3-cookies'
import {
  AUTH_TOKEN_KEY,
  ID_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  EXPIRE_TIME_KEY,
  TOKEN_EXPIRATION_TIME,
  ID_TOKEN_EXPIRATION_TIME,
  REFRESH_TOKEN_EXPIRATION_TIME,
} from 'core/constants'
import { SET_CODE, type Token } from './types'
import dayjs from 'dayjs'

const service = new AuthService()
const { cookies } = useCookies()

const setToken = (params: Token) => {
  const { accessToken, idToken, refreshToken } = params
  cookies.set(AUTH_TOKEN_KEY, accessToken, TOKEN_EXPIRATION_TIME)
  cookies.set(EXPIRE_TIME_KEY, dayjs().add(30, 'minutes').format(), TOKEN_EXPIRATION_TIME)
  cookies.set(ID_TOKEN_KEY, idToken, ID_TOKEN_EXPIRATION_TIME)
  cookies.set(REFRESH_TOKEN_KEY, refreshToken, REFRESH_TOKEN_EXPIRATION_TIME)
}

export const actions: ActionTree<AuthState, RootState> = {
  actLogin(_, params: UserLogin) {
    return service.login(params).then((resp: LoginResp) => {
      setToken({
        idToken: resp.id_token,
        accessToken: resp.access_token,
        refreshToken: resp.refresh_token,
      })
    })
  },
  actLoginWithEndUserCredential({ commit }, params: UserLogin) {
    return service.loginWithEndUserCredential(params).then((resp) => commit(SET_CODE, resp.code))
  },
  actLogout() {
    return service
      .logout({
        id_token: cookies.get('id-token'),
      })
      .then(() => {
        cookies.remove(AUTH_TOKEN_KEY)
        cookies.remove(ID_TOKEN_KEY)
        cookies.remove(REFRESH_TOKEN_KEY)
        window.location.href = '/login'
      })
  },
  actSetToken(_, params) {
    setToken(params)
  },
  actRenewToken() {
    return service.renewToken()
  },
  actForgotPassword(_, params) {
    return service.forgotPassword(params)
  },
  actResetPassword(_, params) {
    return service.resetPassword(params)
  },
  actAdminForgotPassword(_, params) {
    return service.adminForgotPassword(params)
  },
  actVerifyToken(_, params) {
    return service.verifyToken(params)
  },
}
